import { FC, useState } from "react";
import {
  DialogActions,
  DialogContent,
  DialogContentText,
  FormControl,
  MenuItem,
  Select,
  TextField,
  Typography,
} from "@material-ui/core";
import { closeModal } from "actions/modalActions";
import { useDispatch } from "react-redux";
import { OnChangeEvent } from "types/general";
import { fleetReportsMultipleUpdateReports } from "actions/fleetReportsAction";
import { paymentMethods } from "constants/constants";
import { formatNumberType } from "utils/formatNumbers";
import { useModalStyles } from "../styles";
import { CustomButton } from "componentsNew/buttons/CustomButton";

interface FleetReportsUpdateDialogProps {}

export const FleetReportsUpdateDialog: FC<FleetReportsUpdateDialogProps> = () => {
  const classes = useModalStyles();
  const dispatch = useDispatch();
  const [invoiceNumber, setInvoiceNumber] = useState<string>("");
  const [invoiceDate, setInvoiceDate] = useState<string>("");
  const [invoiceAmount, setInvoiceAmount] = useState<number>(0);
  const [paymentDate, setPaymentDate] = useState<string>("");
  const [paymentAmount, setPaymentAmount] = useState<number>(0);
  const [paymentMethod, setPaymentMethod] = useState<number>(0);

  const closenModal = () => dispatch(closeModal());

  const handleSubmit = () => {
    dispatch(
      fleetReportsMultipleUpdateReports(
        invoiceNumber,
        invoiceDate,
        invoiceAmount,
        paymentDate,
        paymentAmount,
        paymentMethod,
      ),
    );
    closenModal();
  };

  return (
    <>
      <DialogContent>
        <DialogContentText>
          <FormControl fullWidth style={{ marginBottom: "12px" }}>
            <Typography className={classes.textLabel}>Invoice Number</Typography>
            <TextField
              variant="outlined"
              value={invoiceNumber}
              name={`invoice_number`}
              onChange={(e: OnChangeEvent) => setInvoiceNumber(e.target.value)}
              inputProps={{
                style: {
                  minWidth: "80px",
                },
              }}
            />
          </FormControl>
          <FormControl fullWidth style={{ marginBottom: "12px" }}>
            <Typography className={classes.textLabel}>Invoice Date</Typography>
            <TextField
              variant="outlined"
              value={invoiceDate}
              type="date"
              onChange={(e: OnChangeEvent) => setInvoiceDate(e.target.value)}
              inputProps={{ shrink: true }}
            />
          </FormControl>
          <FormControl fullWidth style={{ marginBottom: "12px" }}>
            <Typography className={classes.textLabel}>Invoice Value</Typography>
            <TextField
              type="number"
              variant="outlined"
              defaultValue={formatNumberType(Number(invoiceAmount)) || "0.00"}
              value={invoiceAmount}
              onChange={(e: OnChangeEvent) => setInvoiceAmount(e.target.value)}
              inputProps={{
                style: {
                  minWidth: "80px",
                },
              }}
            />
          </FormControl>
          <FormControl fullWidth style={{ marginBottom: "12px" }}>
            <Typography className={classes.textLabel}>Payment Date</Typography>
            <TextField
              variant="outlined"
              value={paymentDate}
              type="date"
              onChange={(e: OnChangeEvent) => setPaymentDate(e.target.value)}
              inputProps={{ shrink: true }}
            />
          </FormControl>
          <FormControl fullWidth style={{ marginBottom: "12px" }}>
            <Typography className={classes.textLabel}>Payment Amount</Typography>
            <TextField
              type="number"
              variant="outlined"
              defaultValue={formatNumberType(Number(paymentAmount)) || "0.00"}
              value={paymentAmount}
              onChange={(e: OnChangeEvent) => setPaymentAmount(e.target.value)}
              inputProps={{
                style: {
                  minWidth: "80px",
                },
              }}
            />
          </FormControl>
          <FormControl fullWidth style={{ marginBottom: "12px" }}>
            <Typography className={classes.textLabel}>Payment Method</Typography>
            <Select
              variant="outlined"
              value={paymentMethod}
              onChange={(e: OnChangeEvent) => setPaymentMethod(e.target.value)}
              placeholder="Off target area"
            >
              {paymentMethods?.map(({ name, value }) => (
                <MenuItem key={`${name}-${value}`} value={value}>
                  {name}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        </DialogContentText>
      </DialogContent>
      <DialogActions className={classes.dialogActions} data-testid="testDialogWrapperModal">
        <CustomButton buttonText={"Cancel"} onClick={closenModal} variant="text" />
        <CustomButton buttonText={"Save"}  onClick={handleSubmit} variant="contained" disabled={!(invoiceNumber && invoiceDate && paymentDate)} />
      </DialogActions>
    </>
  );
};
